import Helper from './Helper';

class SidebarMobile {
  constructor(config = {}) {
    const {
      sidebarTriggerButtonSelector,
      sidebarFurtherLinks
    } = config;

    this.sidebarTriggerButtonSelector = sidebarTriggerButtonSelector;
    this.sidebarTriggerButton = Array.prototype.slice.call(document.querySelectorAll(this.sidebarTriggerButtonSelector));
    this.sidebarFurtherLinks = document.querySelector(sidebarFurtherLinks);

    this.sidebarOpen = false;

    if (this.sidebarTriggerButton && this.sidebarTriggerButton.length !== 0) {
      this.bindEvents();
    }

    if(this.sidebarFurtherLinks){
      this.bindFurtherLinksEvent();
    }
  }

  bindEvents() {
    this.sidebarTriggerButton.forEach(el => {
      el.addEventListener("click", (e) => {
        let sidebar = Helper.getClosest(el, '.sidebar');
        sidebar.classList.toggle("open");

        this.sidebarOpen = this.sidebarOpen ? false : true;
      });

      el.click();

      window.addEventListener("scroll", e => {
        if(this.sidebarOpen){
          el.click();
        }
      });
    });
  }

  bindFurtherLinksEvent(){
    this.sidebarFurtherLinks.addEventListener("click", (e) => {
      document.querySelector(".sidebar__btn--further").classList.toggle("sidebar__btn--active");
    });
  }

} export default SidebarMobile;
